import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  inputBtn: {
    position: 'absolute',
    zIndex: '-1',
    opacity: 0,
    display: 'none'
  },
  buttonWrap: {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'relative',
    padding: 0,
    marginTop: 25
  },
  uploadFileBtnLabel: {
    maxWidth: '100%'
  },
  uploadFileBtn: {
    width: 350,
    maxWidth: '100%'
  }
})

export default useStyles
